import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './auth/AuthContext';
import ProtectedRoute from './auth/ProtectedRoute';
import Login from './auth/Login';
import Navbar from './components/Navbar';
import AdminNavigator from './components/AdminNavigator';
import Dashboard from './pages/Dashboard';
import ClassifyDocument from './pages/ClassifyDocument';
import ManagePolicies from './pages/ManagePolicies';
import Settings from './pages/Settings';
import Testing from './pages/Testing';
import UserManagement from './pages/UserManagement';
import PDFViewer from './pages/PDFViewer';
import QueryHistory from './pages/QueryHistory';
import CaseList from './pages/CaseList';
import CaseDashboard from './pages/CaseDashboard';
import ReviewWorkflow from './pages/ReviewWorkflow';
import LegalDiscovery from './pages/LegalDiscovery';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Router>
          <div className="min-h-screen bg-gray-50">
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/*" element={
                <ProtectedRoute>
                  <Navbar />
                  <main className="container mx-auto px-4 py-8">
                    <Routes>
                      <Route path="/" element={<Dashboard />} />
                      <Route path="/classify" element={
                        <ProtectedRoute requiredPermission="classify_documents">
                          <ClassifyDocument />
                        </ProtectedRoute>
                      } />
                      <Route path="/policies" element={
                        <ProtectedRoute requiredPermission="manage_policies">
                          <ManagePolicies />
                        </ProtectedRoute>
                      } />
                      <Route path="/cases" element={
                        <ProtectedRoute requiredPermission="discovery_process">
                          <CaseList />
                        </ProtectedRoute>
                      } />
                      <Route path="/cases/:caseId" element={
                        <ProtectedRoute requiredPermission="discovery_process">
                          <CaseDashboard />
                        </ProtectedRoute>
                      } />
                      <Route path="/cases/:caseId/review" element={
                        <ProtectedRoute requiredPermission="discovery_process">
                          <ReviewWorkflow />
                        </ProtectedRoute>
                      } />
                      <Route path="/discovery" element={
                        <ProtectedRoute requiredPermission="discovery_process">
                          <LegalDiscovery />
                        </ProtectedRoute>
                      } />
                      <Route path="/testing" element={
                        <ProtectedRoute requiredPermission="classify_documents">
                          <Testing />
                        </ProtectedRoute>
                      } />
                      <Route path="/settings" element={
                        <ProtectedRoute requiredPermission="manage_configs">
                          <Settings />
                        </ProtectedRoute>
                      } />
                      <Route path="/users" element={
                        <ProtectedRoute requiredPermission="manage_users">
                          <UserManagement />
                        </ProtectedRoute>
                      } />
                      <Route path="/pdf-viewer" element={<PDFViewer />} />
                      <Route path="/history" element={<QueryHistory />} />
                    </Routes>
                  </main>
                </ProtectedRoute>
              } />
            </Routes>
            <AdminNavigator />
          </div>
        </Router>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
